import React, { useEffect, useRef, useState } from "react";
import ProgressSteps from "../components/ProgressSteps";
import FormField from "../components/FormField";
import DateField from "../components/DateField";
import SignaturePad from "../components/SignaturePad";
import {
  completeBuyerContract,
  createContract,
  getContract,
} from "../api/contractApi";
import { getStoredProfileSignature } from "../utils/profileSignature";
import { applyProfilePersonalInfo } from "../utils/profilePersonalInfo";
import { getCurrentUser } from "../api/authApi";

const INITIAL_BUYER_DATA = {
  buyer: {
    firstName: "",
    lastName: "",
    fatherName: "",
    idNumber: "",
    nationalCode: "",
    idIssuePlace: "",
    birthDate: "",
    address: "",
    phone: "",
    mobile: "",
    signature: null,
  },
};

const BUYER_STEPS = [{ title: "اطلاعات هویتی" }, { title: "بازبینی و امضا" }];

function SummaryRow({ label, value }) {
  if (!value) return null;
  console.log(label, ":", value);
  return (
    <div className="flex justify-between gap-4 border-b border-gray-100 py-2 text-sm last:border-b-0">
      <span className="text-gray-500">{label}</span>
      <span className="font-medium text-navy">{value}</span>
    </div>
  );
}

const CONDITION_LABELS = {
  healthy: "سالم و بدون نقص",
  minor_issue: "دارای ایراد جزئی",
  needs_repair: "نیازمند تعمیر",
};

const PARTY_LABELS = { seller: "فروشنده", buyer: "خریدار" };

function BuyerPersonalInfo({ data, onChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">اطلاعات هویتی خریدار</h2>
      <p className="mt-1 text-sm text-gray-500">
        اطلاعات شناسایی خود را مطابق کارت ملی و شناسنامه وارد کنید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormField
          label="نام"
          name="buyerFirstName"
          value={data.buyerFirstName}
          onChange={onChange}
          placeholder="مثلاً محمد"
          required
        />
        <FormField
          label="نام خانوادگی"
          name="buyerLastName"
          value={data.buyerLastName}
          onChange={onChange}
          placeholder="مثلاً رضایی"
          required
        />
        <FormField
          label="نام پدر"
          name="buyerFatherName"
          value={data.buyerFatherName}
          onChange={onChange}
          placeholder="مثلاً احمد"
          required
        />
        <FormField
          label="شماره شناسنامه"
          name="buyerIdNumber"
          value={data.buyerIdNumber}
          onChange={onChange}
          placeholder="شماره شناسنامه"
          required
        />
        <FormField
          label="کد ملی"
          name="buyerNationalCode"
          value={data.buyerNationalCode}
          onChange={onChange}
          placeholder="کد ملی ۱۰ رقمی"
          required
        />
        <FormField
          label="محل صدور شناسنامه"
          name="buyerIdIssuePlace"
          value={data.buyerIdIssuePlace}
          onChange={onChange}
          placeholder="مثلاً اصفهان"
          required
        />

        <DateField
          label="تاریخ تولد"
          name="buyerBirthDate"
          value={data.buyerBirthDate}
          onChange={onChange}
          required
        />
        <FormField
          label="تلفن همراه"
          name="buyerMobile"
          type="tel"
          value={data.buyerMobile}
          onChange={onChange}
          placeholder="مثلاً ۰۹۱۲۱۲۳۴۵۶۷"
          required
        />
        <FormField
          label="تلفن ثابت"
          name="buyerPhone"
          type="tel"
          value={data.buyerPhone}
          onChange={onChange}
          placeholder="مثلاً ۰۲۱۸۸۸۸۸۸۸۸"
        />
        <FormField
          label="آدرس"
          name="buyerAddress"
          type="textarea"
          value={data.buyerAddress}
          onChange={onChange}
          placeholder="آدرس کامل محل سکونت"
          full
          required
        />
      </div>
    </div>
  );
}

function BuyerSignatureStep({ sellerData, buyerData, onSignatureChange }) {
  return (
    <div>
      <h2 className="text-lg font-bold text-navy">
        بازبینی قولنامه و امضای خریدار
      </h2>
      <p className="mt-1 text-sm text-gray-500">
        اطلاعات قولنامه را بررسی کنید، سپس امضای خود را ثبت نمایید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            اطلاعات فروشنده
          </h3>
          <SummaryRow
            label="نام و نام خانوادگی"
            value={sellerData.seller?.name}
          />
          <SummaryRow label="کد ملی" value={sellerData.seller?.nationalCode} />
          <SummaryRow label="تلفن همراه" value={sellerData.seller?.mobile} />
        </div>
        <div className="rounded-xl border border-sky/30 bg-sky/5 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            اطلاعات خریدار
          </h3>
          <SummaryRow
            label="نام و نام خانوادگی"
            value={`${buyerData.buyerFirstName || ""} ${buyerData.buyerLastName || ""}`.trim()}
          />
          <SummaryRow label="کد ملی" value={buyerData.buyerNationalCode} />
          <SummaryRow label="تلفن همراه" value={buyerData.buyerMobile} />
        </div>
        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">
            اطلاعات خودرو
          </h3>
          <SummaryRow
            label="نام و مدل"
            value={`${sellerData.vehicle?.name || ""} ${sellerData.vehicle?.model || ""}`.trim()}
          />
          <SummaryRow label="رنگ" value={sellerData.vehicle?.color} />
          <SummaryRow label="پلاک" value={sellerData.vehicle?.plateNumber} />
        </div>
        <div className="rounded-xl border border-gray-100 bg-surface/60 p-4">
          <h3 className="mb-2 text-sm font-bold text-sky-dark">مبلغ معامله</h3>
          <SummaryRow
            label="مبلغ به تومان"
            value={
              sellerData.deal?.amountToman &&
              `${Number(sellerData.deal.amountToman).toLocaleString("fa-IR")} تومان`
            }
          />
          <SummaryRow
            label="هزینه نقل و انتقال بر عهده"
            value={PARTY_LABELS[sellerData.transfer?.transferFeeBy]}
          />
          <SummaryRow
            label="وضعیت خودرو"
            value={CONDITION_LABELS[sellerData.delivery?.condition]}
          />
        </div>
      </div>
      <div className="mt-6">
        <label className="mb-1.5 block text-sm font-medium text-navy-light">
          امضای خریدار <span className="text-red-500">*</span>
        </label>
        <SignaturePad
          value={buyerData.buyerSignature}
          onChange={onSignatureChange}
        />
      </div>
    </div>
  );
}

function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-sky border-t-transparent" />
        <p className="text-sm text-gray-500">
          در حال بارگذاری اطلاعات قولنامه...
        </p>
      </div>
    </div>
  );
}

function ErrorScreen({ message }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-card">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-red-100 text-2xl">
          ⚠️
        </div>
        <h2 className="mb-2 text-lg font-bold text-navy">
          خطا در بارگذاری قولنامه
        </h2>
        <p className="text-sm text-gray-500">{message}</p>
      </div>
    </div>
  );
}

export default function BuyerWizard({ contractId, onComplete, onBackToRoles }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [buyerData, setBuyerData] = useState(() => ({
    ...INITIAL_BUYER_DATA,
    buyerSignature: getStoredProfileSignature(),
  }));

  useEffect(() => {
    let active = true;

    getCurrentUser()
      .then((user) => {
        if (!active) return;
        setBuyerData((prev) => ({
          ...prev,
          buyerFirstName:
            prev.buyerFirstName || user?.personalInfo?.firstName || "",
          buyerLastName:
            prev.buyerLastName || user?.personalInfo?.lastName || "",
          buyerFatherName:
            prev.buyerFatherName || user?.personalInfo?.fatherName || "",
          buyerIdNumber:
            prev.buyerIdNumber ||
            user?.personalInfo?.bookletNumber ||
            user?.personalInfo?.idNumber ||
            "",
          buyerNationalCode:
            prev.buyerNationalCode || user?.personalInfo?.nationalCode || "",
          buyerIdIssuePlace:
            prev.buyerIdIssuePlace || user?.personalInfo?.placeOfIssue || "",
          buyerBirthDate:
            prev.buyerBirthDate || user?.personalInfo?.birthDate || "",
          buyerAddress: prev.buyerAddress || user?.personalInfo?.address || "",
          buyerPhone: prev.buyerPhone || user?.personalInfo?.phone || "",
          buyerMobile: prev.buyerMobile || user?.personalInfo?.mobile || "",
        }));
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, []);
  const [sellerData, setSellerData] = useState(null);
  const [loading, setLoading] = useState(Boolean(contractId));
  const [loadError, setLoadError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const formRef = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        const contract = await getContract(contractId);
        console.log(contract);
        if (
          contract.contract.status === "completed" ||
          contract.contract.status === "cancelled"
        ) {
          onComplete(contract.contract);
          return;
        }
        setSellerData(contract.contract);
      } catch (err) {
        setLoadError(err.message || "اطلاعات قولنامه یافت نشد.");
      } finally {
        setLoading(false);
      }
    })();
  }, [contractId]);

  if (loading) return <LoadingScreen />;
  if (loadError) return <ErrorScreen message={loadError} />;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "buyerBirthDate") {
      let v = value.replace(/[^۰-۹0-9/]/g, "").replace(/\/+/g, "/");
      const digits = v.replace(/\//g, "");
      if (digits.length <= 4) v = digits;
      else if (digits.length <= 6)
        v = digits.slice(0, 4) + "/" + digits.slice(4);
      else
        v =
          digits.slice(0, 4) +
          "/" +
          digits.slice(4, 6) +
          "/" +
          digits.slice(6, 8);
      setBuyerData((prev) => ({ ...prev, [name]: v }));
      return;
    }

    setBuyerData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSignatureChange = (dataUrl) => {
    setBuyerData((prev) => ({ ...prev, buyerSignature: dataUrl }));
  };

  const isLastStep = currentStep === BUYER_STEPS.length;
  const isFirstStep = currentStep === 1;

  const handleFinalSubmit = async () => {
    if (!buyerData.buyerSignature) {
      window.alert("لطفاً پیش از ثبت نهایی، امضای خود را وارد کنید.");
      return;
    }
    setSubmitting(true);
    setSubmitError("");
    try {
      const payload = {
        firstName: buyerData.buyerFirstName,
        lastName: buyerData.buyerLastName,
        fatherName: buyerData.buyerFatherName,
        idNumber: buyerData.buyerIdNumber,
        nationalCode: buyerData.buyerNationalCode,
        idIssuePlace: buyerData.buyerIdIssuePlace,
        birthDate: buyerData.buyerBirthDate,
        address: buyerData.buyerAddress,
        phone: buyerData.buyerPhone,
        mobile: buyerData.buyerMobile,
        signature: buyerData.buyerSignature,
      };
      if (contractId) {
        await completeBuyerContract(contractId, payload);
        const fullContract = await getContract(contractId);
        onComplete(fullContract.contract);
        return;
      }

      const createdContract = await createContract({
        ...payload,
        createdFor: "buyyer",
        status: "pending_seller",
      });
      onComplete(createdContract);
    } catch (err) {
      setSubmitError(err.message || "خطا در ارتباط با سرور. دوباره تلاش کنید.");
    } finally {
      setSubmitting(false);
    }
  };

  const goNext = () => {
    if (formRef.current && !formRef.current.reportValidity()) return;
    if (isLastStep) {
      handleFinalSubmit();
      return;
    }
    setCurrentStep((s) => s + 1);
  };

  const goBack = () => {
    if (isFirstStep) {
      onBackToRoles();
      return;
    }
    setCurrentStep((s) => s - 1);
  };

  return (
    <div className="min-h-screen bg-surface px-4 py-6 sm:py-10">
      <div className="mx-auto w-full max-w-3xl">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-lg text-white">
            🧾
          </div>
          <div>
            <h1 className="text-base font-extrabold text-navy sm:text-lg">
              قولنامه هوشمند — خریدار
            </h1>
            <p className="text-xs text-gray-500">قرارداد ۲۴</p>
          </div>
        </div>
        <div className="mb-6 rounded-2xl bg-white p-4 shadow-card sm:p-5">
          <ProgressSteps steps={BUYER_STEPS} currentStep={currentStep} />
        </div>
        <form
          ref={formRef}
          onSubmit={(e) => e.preventDefault()}
          className="step-enter rounded-2xl bg-white p-5 shadow-card sm:p-8"
        >
          {currentStep === 1 && (
            <BuyerPersonalInfo data={buyerData} onChange={handleChange} />
          )}
          {currentStep === 2 && (
            <BuyerSignatureStep
              sellerData={sellerData || {}}
              buyerData={buyerData}
              onSignatureChange={handleSignatureChange}
            />
          )}
          {submitError && (
            <p className="mt-4 rounded-lg bg-red-50 px-4 py-2.5 text-sm text-red-600">
              ⚠️ {submitError}
            </p>
          )}
        </form>
        <div className="mt-6 flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={goBack}
            disabled={submitting}
            className="rounded-xl border border-gray-200 bg-white px-6 py-2.5 text-sm font-bold text-navy transition hover:border-sky-light disabled:opacity-50"
          >
            {isFirstStep ? "بازگشت به انتخاب نقش" : "مرحله قبل"}
          </button>
          <button
            type="button"
            onClick={goNext}
            disabled={submitting}
            className="flex items-center gap-2 rounded-xl bg-sky px-8 py-2.5 text-sm font-bold text-white shadow-card transition hover:bg-sky-dark disabled:opacity-60"
          >
            {submitting && (
              <svg
                className="h-4 w-4 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8z"
                />
              </svg>
            )}
            {submitting
              ? "در حال ثبت..."
              : isLastStep
                ? "ثبت نهایی و مشاهده قولنامه"
                : "مرحله بعد"}
          </button>
        </div>
      </div>
    </div>
  );
}
